var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceSms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M23.8768 32.3984H21.4463V32.4822H23.8768V32.3984Z",
    fill: "#76BC21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.1165 22.1602H16.686V22.244H19.1165V22.1602Z",
    fill: "#76BC21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2491 11.1117H20.7757M10.2491 15.9894H20.7757M36.75 18.8892V35.4669L34.4201 34.193L31.3023 32.5H17.8424C15.7471 32.5 14.0541 30.8071 14.0541 28.7118V22.2584H22.9716C23.927 22.2584 24.7819 21.8729 25.4188 21.2527C26.0893 20.6157 26.4916 19.7273 26.4916 18.7384V15.1178H32.9618C35.057 15.1178 36.75 16.8107 36.75 18.8892ZM26.5084 6.11653V18.4534C26.5084 20.5487 24.8154 22.2417 22.7201 22.2417H9.26018L3.8125 25.2085V8.6476C3.8125 6.55235 5.50547 4.85938 7.60073 4.85938H25.2512C25.9552 4.85938 26.5084 5.42929 26.5084 6.11653Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceSms);
export default __webpack_public_path__ + "static/media/serviceSMS.e15f44fb0aeaabfc184d1d0933ab28b5.svg";
export { ForwardRef as ReactComponent };